import React, { ReactNode } from "react"
import posthog from "posthog-js"

import ErrorMessage from "./shared/ErrorMessage"

interface CustomErrorBoundaryProps {
  children: ReactNode
}

interface CustomErrorBoundaryState {
  hasError: boolean
  error: Error | null
  errorInfo: React.ErrorInfo | null
}

class CustomErrorBoundary extends React.Component<CustomErrorBoundaryProps, CustomErrorBoundaryState> {
  constructor(props: CustomErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error: Error): CustomErrorBoundaryState {
    return { hasError: true, error, errorInfo: null }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("React error boundary caught an error:", error, errorInfo)
    if (import.meta.env.DEV) return
    posthog.capture("react_error", {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      pathname: window.location.pathname,
    })

    this.setState({ errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return <ErrorMessage />
    }

    return this.props.children
  }
}

export default CustomErrorBoundary
